import SellerGeneralInformationForm from './SellerGeneralInformationForm'

export default SellerGeneralInformationForm
